import { useMemo } from "react";

interface UseSwapFeeCheckProps {
  gasFeeUsd: number;
  balance: number;
  fromAmount: number;
  nativeTokenPriceUsd: number;
  loading: boolean;
}

const useSwapFeeCheck = ({
  gasFeeUsd,
  balance,
  fromAmount,
  nativeTokenPriceUsd,
  loading,
}: UseSwapFeeCheckProps): boolean => {
  return useMemo(() => {
    const gasFeeInNative = gasFeeUsd / nativeTokenPriceUsd;
    return gasFeeInNative + fromAmount <= balance;
  }, [gasFeeUsd, nativeTokenPriceUsd, balance, fromAmount, loading]);
};

export default useSwapFeeCheck;
